/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

//------------------------------------------------INDICES-------------------------------------------------
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';
import { number_children } from '../helper_functions';

// NDWI (Water Index) > 0.0 -> water present
Blockly.Blocks['analyse_ndwi'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("NDWI  ");
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown([['Minimum','min'],['Mean','mean'],['Median', 'median'],['Maximum', 'max'],['95th Percentile', 'p95']], this.validateNDWIDropdown), 'type');
        this.getField('type').setValue('mean')

        this.setPreviousStatement(true, 'indices');
        this.setNextStatement(true, getAllowedOutputs('indices'));
        this.setInputsInline(true);
        this.setStyle('indices');
        this.setTooltip(Blockly.Msg.NDWI_BLOCK_TOOLTIP);
        this.setHelpUrl("");

        this.setOnChange(() => {
            if ((this.getSurroundParent() !== null) && (this.getSurroundParent().type == 'analyse_timeseries')) {
                if (number_children(this.getSurroundParent(), this.id) > 1) {
                    this.unplug();
                }
            }
        });
    },

    /**
     * parses new dropdown option and sets block property, bands
     * @param {String} newValue 
     * @returns {String} validated value
     */
     validateNDWIDropdown(newValue) {
        let sourceBlock = this.getSourceBlock()
        switch(newValue){
            case 'min':
                sourceBlock.bands = [['Min NDWI', 'indexband_min']]
                break;
            case 'mean':
                sourceBlock.bands = [['Mean NDWI', 'indexband_mean']]
                break;
            case 'median':
                sourceBlock.bands = [['Median NDWI', 'indexband_median']]
                break;
            case 'max':
                sourceBlock.bands = [['Max NDWI', 'indexband_max']]
                break;
            case 'p95':
                sourceBlock.bands = [['95th Percentile NDWI', 'indexband_p95']]
                break;
            default:
                sourceBlock.bands = null
        }

        return newValue;
    }
};